import React from 'react';

const PortfolioLayout = ({ children }: { children?: React.ReactNode }) => (
  <div className="relative min-h-dvh w-dvw">
    <div className="fixed inset-0 -z-10 bg-revamp-cobalt-400" aria-hidden />
    {children}
  </div>
);

export default PortfolioLayout;
